module.exports = __webpack_public_path__ + "static/img/serch.da06f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/serch.png
// module id = gtm1
// module chunks = 66